import { render, staticRenderFns } from "./guest.vue?vue&type=template&id=a13f5064&scoped=true&"
import script from "./guest.vue?vue&type=script&lang=js&"
export * from "./guest.vue?vue&type=script&lang=js&"
import style0 from "./guest.vue?vue&type=style&index=0&id=a13f5064&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a13f5064",
  null
  
)

export default component.exports